import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { REPORT_TYPES, REPORT_ORDER, getReportType } from './reportTypes';

const getAuthHeaders = () => {
  const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
  return { headers: { Authorization: `Bearer ${token}` } };
};

const AddReport = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialType = getReportType(searchParams.get('type')).key;

  const [typeKey, setTypeKey] = useState(initialType);
  const config = getReportType(typeKey);
  const [formData, setFormData] = useState(config.emptyForm);
  const [loading, setLoading] = useState(false);

  const handleTypeChange = (key) => {
    const next = getReportType(key);
    setTypeKey(next.key);
    setFormData(next.emptyForm);
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      setFormData((prev) => ({
        ...prev,
        [name]: files && files.length > 0 ? files[0] : null,
      }));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const current = getReportType(typeKey);
    for (const field of current.fields) {
      if (field.required) {
        const val = formData[field.name];
        if (field.type === 'file' && !val) {
          toast.error(`${field.label} is required`);
          return;
        }
        if (field.type !== 'file' && (val === undefined || String(val).trim() === '')) {
          toast.error(`${field.label} is required`);
          return;
        }
      }
    }

    setLoading(true);

    const payload = new FormData();
    current.fields.forEach((field) => {
      if (field.type === 'file') {
        if (formData[field.name]) payload.append(field.name, formData[field.name]);
      } else if (formData[field.name] !== undefined) {
        payload.append(field.name, formData[field.name]);
      }
    });

    try {
      const response = await postRequest(current.endpoint, payload, getAuthHeaders());
      if (response?.data?.success) {
        toast.success(`${current.label} created successfully`);
        navigate(`/reports?type=${typeKey}`);
      } else {
        toast.error(response?.data?.message || `Failed to create ${current.label.toLowerCase()}`);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || `Failed to create ${current.label.toLowerCase()}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="font-weight-bold">Add Report</h4>
      </div>

      <form onSubmit={handleSubmit} className="form-style">
        <div className="row mx-4 mt-4">
          <div className="col-12">
            <div className="lables">Report Type *</div>
            <div className="d-flex flex-wrap gap-2">
              {REPORT_ORDER.map((key) => (
                <button
                  key={key}
                  type="button"
                  className={`btn mr-2 ${typeKey === key ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleTypeChange(key)}
                >
                  {REPORT_TYPES[key].label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="row mx-4 mt-4">
          {config.fields.map((field) => (
            <div className="col-md-6 mt-2" key={field.name}>
              <label htmlFor={field.name} className="lables">
                {field.label} {field.required ? '*' : '(optional)'}
              </label>

              {field.type === 'select' && (
                <select
                  id={field.name}
                  name={field.name}
                  className="form-control"
                  value={formData[field.name] || ''}
                  onChange={handleChange}
                >
                  {field.options.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              )}

              {field.type === 'textarea' && (
                <textarea
                  id={field.name}
                  name={field.name}
                  rows="3"
                  className="form-control"
                  value={formData[field.name] || ''}
                  onChange={handleChange}
                />
              )}

              {field.type === 'file' && (
                <>
                  <input
                    id={field.name}
                    name={field.name}
                    type="file"
                    className="form-control-file"
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.zip,image/*"
                    onChange={handleChange}
                  />
                  {formData[field.name] && (
                    <small className="text-muted d-block mt-1">
                      Selected: {formData[field.name].name}
                    </small>
                  )}
                </>
              )}

              {!['select', 'textarea', 'file'].includes(field.type) && (
                <input
                  id={field.name}
                  name={field.name}
                  type={field.type || 'text'}
                  className="form-control"
                  value={formData[field.name] ?? ''}
                  onChange={handleChange}
                />
              )}
            </div>
          ))}
        </div>

        <div className="mt-5 text-right mx-4">
          <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
            {loading ? 'Creating...' : `Create ${config.label}`}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddReport;
